import DocumentHeader from "./partials/DocumentHeader";
import {
  construirPartidasConDetalle,
  getHashedRows,
  toNumber,
} from "../../services/mappings";
import ItemsTable from "./partials/ItemsTable";
import DocumentFooter from "./partials/DocumentFooter";

function AmsaPDF({
  headers,
  partidas,
  incrementos,
  detalles,
  contract,
  polinomios,
}) {
  const itemsList = construirPartidasConDetalle(partidas, detalles);

  const hashRows = getHashedRows(detalles);
  const hashTotals = hashRows.reduce(
    (acc, r) => {
      const det = r?.detalle ?? {};
      return {
        scTot: acc.scTot + toNumber(det?.montO_TOTCONT_MONTO_BASE_MC),
        amaTot: acc.amaTot + toNumber(det?.acuM_ANTERIOR_MONTO_PAGO_MC),
        paTot: acc.paTot + toNumber(det?.eP_MES_MONTO_PAGO_MC),
        taTot: acc.taTot + toNumber(det?.acuM_MONTO_PAGO_MC),
      };
    },
    { scTot: 0, amaTot: 0, paTot: 0, taTot: 0 },
  );
  const moneda = headers?.data?.moneda ?? headers?.moneda ?? "";

  return (
    <>
      <DocumentHeader headers={headers} contract={contract} />
      <ItemsTable
        items={itemsList}
        incrementos={incrementos}
        detalles={detalles}
        hashRows={hashRows}
        hashTotals={hashTotals}
        moneda={moneda}
      />
      <DocumentFooter
        headers={headers}
        items={itemsList}
        incrementos={incrementos}
        indicesReajuste={headers?.indicesReajuste}
        polinomios={polinomios}
      />
    </>
  );
}

export default AmsaPDF;
